import * as React from 'react';
import './footer.scss';

import rocketmakers from '../assets/rm-full-logo.svg';
import techsparkFooter from '../assets/ts-full-logo.svg';
import logo from '../assets/logo.svg';

const Footer: React.FunctionComponent<{}> = () => {
  return (
    <div className="footer">
      <div className="fixed-width">
        <div className="logos-container">
          <img src={logo} />
          <img src={techsparkFooter} />
          <img src={rocketmakers} />
        </div>
      </div>
    </div>
  );
};

export default Footer;
